import { EngineEnum, WeekDayEnum } from './types';

export const WEEK_DAY_OPTIONS: { value: WeekDayEnum; label: string }[] = [
	{ value: WeekDayEnum.MONDAY, label: 'Lunes' },
	{ value: WeekDayEnum.TUESDAY, label: 'Martes' },
	{ value: WeekDayEnum.WEDNESDAY, label: 'Miércoles' },
	{ value: WeekDayEnum.THURSDAY, label: 'Jueves' },
	{ value: WeekDayEnum.FRIDAY, label: 'Viernes' },
	{ value: WeekDayEnum.SATURDAY, label: 'Sábado' },
	{ value: WeekDayEnum.SUNDAY, label: 'Domingo' },
];

export const ENGINE_OPTIONS: { value: EngineEnum; label: string }[] = [
	{ value: EngineEnum.BUSES, label: 'Buses' },
	{ value: EngineEnum.CARS, label: 'Autos' },
	{ value: EngineEnum.CRUISES, label: 'Cruceros' },
	{ value: EngineEnum.FERRY, label: 'Ferry' },
	{ value: EngineEnum.FLIGHTS, label: 'Vuelos' },
	{ value: EngineEnum.HOTELS, label: 'Hoteles' },
	{ value: EngineEnum.PACKAGES, label: 'Paquetes' },
	{ value: EngineEnum.TOURS, label: 'Tours' },
	{ value: EngineEnum.INSURANCES, label: 'Seguros' },
];
